import jaLocale from 'element-ui/lib/locale/lang/ja'
export default {
	all:{
		jiantizhongwen:'簡体字中国語',
		fantizhongwen:'繁体字中国語',
		yingwen:'英語',
		ribenyu:'日本語',
		hanguoyu:'韓国語',
		jizhuzhanghao:'アカウントを記憶',
		jizhumima:'パスワードを記憶',
		yuyanxuanze:'言語選択',
		shezhi:'設定',
		xiugaimima:'パスワードの変更',
		yinsizhengce:'プライバシーポリシー',
		guanyuwomen:'私たちについて',
		mimashuoming:'パスワードは8〜20文字の大文字小文字の英字と数字の組み合わせでなければなりません。純粋な数字または純粋な英字は使用できません',
		qingshurujiumima:'古いパスワードを入力してください',
		qingshuruxinmima:'新しいパスワードを入力してください',
		quedingxiugai:'変更を確認',
		
		shouye:'ホーム',
		zhibo:'ライブ',
		wode:'マイページ',
		xitongxiaoxi:'システムメッセージ',
		wodedingdan:'私の注文',
		bangzhufankui:'ヘルプフィードバック',
		xiugaiziliao:'プロフィールの変更',
		xiaofeimingxi:'消費明細',
		zhibojilu:'ライブ記録',
		tijiao:'提出',
		caozuochenggong:'操作成功',
		tishi:'通知',
		quedingtuichudengluma:'ログアウトしますか？',
		queding:'確定',
		wentibangzhu:'問題ヘルプ',
		woyaofankui:'フィードバック',
		fankuiwenti:'フィードバック問題',
		qingmiaoshuniyaofankuidewenti:'フィードバックしたい問題を説明してください...',
		sousuo:'検索',
		sousuoniganxingqudeneirong:'興味のあるコンテンツを検索',
		zhibojianbiaoti:'ライブタイトル',
		zhibojianbeijing:'ライブ背景',
		xuanzebackground:'背景選択',
		shangchuanbeijing:'背景アップロード',
		yixuanze:'選択済み',
		qingxuanzebeijing:'背景を選択してください',
		zhibojianbiaoqian:'ライブタグ',
		zhibojianhuazhi:'ライブ画質',
		geinidezhibojianqugemingziba:'ライブルームに名前を付けてください~',
		qingshurukaibomiyao:'ストリームキーを入力してください',
		kaishizhibo:'ライブを開始',
		shengyin:'音声',
		liwutexiao:'ギフト効果',
		gengduo:'もっと',
		gouwuche:'ショッピングカート',
		zaixianguanzhong:'オンライン視聴者',
		danmushuoming:'プラットフォームは未成年者のチャージとチップを厳禁しています。遊び同伴などでチップを誘導したり、プライベート取引をしたりすることは禁止されています。また、ポルノ、政治、罵詈雑言などのコンテンツも禁止されています。財産の安全に注意し、ネット詐欺にご用心ください。理性的に消費してください。',
		tianjiaguanliyuan:'管理者を追加',
		jinyan:'ミュート',
		jiechuejinyan:'ミュート解除',
		tichufangjian:'部屋から追い出す',
		shangpinxiangqing:'商品詳細',
		lijijiagou:'即購入',
		xuanzeguige:'仕様を選択',
		quanbuliwu:'全てのギフト',
		ge:'個',
		bi:'コイン',
		guanliyuan:'管理者',
		kuaijieduanyu:'クイックフレーズ',
		gonggao:'お知らせ',
		xinzengkuaijieduanyu:'新しいクイックフレーズ',
		qingshuru:'入力してください',
		qingshuruzhengque:'正しい金額を入力してください',
		shuru:'入力',
		wangjimima:'パスワードを忘れた',
		youxiangzhuce:'メール登録',
		huoquyanzhengma:'認証コードを取得',
		qingshuruningdeyouxiangzhanghao:'メールアカウントを入力',
		qingshuruyanzhengma:'認証コードを入力してください',
		qingshurumima:'パスワードを入力してください',
		mimadenglu:'パスワードログイン',
		woyiyuedubingtongyi:'読みました。同意します',
		yonghuxieyi:'利用規約',
		yinsixieyi:'プライバシー契約',
		denglu:'ログイン',
		chongxindenglu:'再ログイン',
		xiayibu:'次のステップ',
		haimeizhanghao:'アカウントをお持ちでない方',
		quzhuce:'登録に行く',
		yiyouzhanghao:'アカウントをお持ちの方',
		qudenglu:'ログインに行く',
		shezhijibenxinxi:'基本情報の設定',
		nichengtishi:'英字、数字、句読点のみ使用可能です。最小6文字、空白は使用できません',
		shezhiyonghuming:'ユーザー名の設定',
		yonghumingtishi:'ユーザー名は6〜18文字の大文字小文字の英字または数字です',
		shezhijiaoyimima:'取引パスワードの設定',
		jiaoyimimatishi:'取引パスワードは6桁の数字の組み合わせでなければなりません',
		qingxuanze:'選択してください',
		yaoqingma:'招待コード（任意）',
		qingshuruyaoqingma:'招待コードを入力',
		shezhixinmima:'新しいパスワードの設定',
		xuanzeningdeguojia:'国を選択',
		zhuce:'登録',
		qingshuruyonghuming:'ユーザー名を入力してください',
		gaoqinghuazhi:'高清画質',
		biaoqinghuazhi:'標準画質',
		chaoqinghuazhi:'超清画質',
		putonghuazhi:'通常画質',
		zengsong:'贈る',
		jinrulezhibojian:'ライブルームに入る',
		shuodianshenmene:'何か言いたいこと...',
		zanwushuju:'データなし',
		songgei:'贈る',
		huifang:'リプレイ',
		xunibi:'仮想通貨',
		quanbu:'全て',
		appxiazai:'アプリダウンロード',
		dingdanjine:'注文金額',
		dingdanbianhao:'注文番号',
		chuangjianshijian:'作成時間',
		zhubozanshilikai:'配信者が一時的に離れています',
		mashanghuilai:'すぐに戻ります',
		guojianzhuoxiazai:'国際版Androidダウンロード',
		anzhuoxiazai:'Androidダウンロード',
		guojipingguoxiazai:'国際版iOSダウンロード',
		pingguoxiazai:'iOSダウンロード',
		quanbushangpin:'全ての商品',
		yiqiangguang:'売り切れ',
		jiagou:'カートに追加',
		yixuan:'選択済み',
		xuanzeguiige:'スペックを選択',
		xuazeguige:'仕様を選択',
		shangchuanzhong:'アップロード中',
		shangchuanshibai:'アップロード失敗',
		browserbu支持:'ブラウザがメディアデバイスへのアクセスをサポートしていません',
		qingkaiqi:'カメラとマイクの権限を有効にしてください',
		meiyoushebei:'カメラまたはマイクデバイスが検出されません',
		shebeibeizhan:'デバイスが他のプログラムによって使用されています。閉じてからやり直してください',
		quxianchengong:'メディア権限の取得に失敗しました',
		shifouquedingjieshuzhibo:'ライブを終了しますか？',
		qingyuedubingtongyiyonghuxieyiheyinsixieyi:'利用規約とプライバシー契約を読み同意してください！',
		quedingqudengluma:'ログインしますか？',
		duanyingyin:'ショートビデオ',
		fabuduanyingyin:'ショートビデオを公開',
		zhibohuaxu:'ライブハイライト',
		qingshurubiaoti:'タイトルを入力してください',
		shangchuanduanyingyin:'ショートビデオをアップロード',
		zhibozhongxin:'ライブセンター',
		zongzichanguzhi:'総資産価値',
		liushuijilu:'取引履歴',
		chongbi:'入金',
		tibi:'出金',
		dashang:'チップ',
		riqi:'日付',
		leixing:'種類',
		miaoshu:'説明',
		jine:'金額',
		zhuangtai:'状態',
		yiwancheng:'完了',
		shenhezhong:'審査中',
		shenhejujue:'審査却下',
		kaishiriqi:'開始日',
		jieshuriqi:'終了日',
		wangluo:'ネットワーク',
		dizhi:'アドレス',
		tibishuliang:'出金額',
		daozhangshisuan:'到着予測',
		shouxufei:'手数料',
		meiridaozhang:'毎日到着',
		keyong:'利用可能',
		dongjie:'凍結',
		zuixiaotibishuliang:'最小出金額',
		shouxufeibilv:'手数料',
		meirishenyueddu:'毎日残り限度額',
		shenqingzhibo:'ライブ申請',
		shenqingjilu:'申請記録',
		huifangjilu:'リプレイ記録',
		yikaifang:'開放済み',
		guankanhuifang:'リプレイを見る',
		beisu:'速度',
		zhiboriqi:'配信日',
		shijianshiduan:'時間帯',
		shoujizhibo:'モバイル配信',
		zhibodaihuo:'ライブコマース',
		kaiqi:'オン',
		guanbi:'オフ',
		beizhu:'備考',
		huodongzhuti:'テーマ、機器の説明',
		shenqinghouliucheng:'申請後の流れ',
		shenqinghouliuchengdesc:'審査通過後、配信アドレスがメールで送信されます。',
		daishenhe:'審査待ち',
		tijiaoshenqing:'申請を提出',
		qingxuanzeriqi:'配信日を選択してください',
		qingxuanzeshijian:'時間帯を選択してください',
		tijiaochenggong:'提出成功',
		nian:'年',
		yue:'月',
		tongshiduanbukezhongfu:'同時間帯は重複不可',
		keshenqingshiduan:'申請可能な時間帯',
		querenShiduan:'確認',
		zhanghaoid:'アカウント ID',
		qingtianxie:'入力してください',
		zhou1:'月',
		zhou2:'火',
		zhou3:'水',
		zhou4:'木',
		zhou5:'金',
		zhou6:'土',
		zhou7:'日',
		shenqingyitijiao:'申請が提出されました',
		shenqingtijiaodesc:'管理者が配信ルーム、時間帯、商品情報を審査します。',
		chakanshenheJilu:'審査記録を確認',
		shenqingriqi:'申請日',
		zhiboshijianduan:'配信時間帯',
		zhiboleixing:'配信タイプ',
		daihuo:'ライブコマース',
		yitongguo:'承認済み',
		weitongguo:'未承認',
		xiangqing:'詳細',
		yuanyin:'理由',
		shenqingxiangqing:'申請詳細',
		shenheyuanyin:'審査理由',
		xutiaozheng:'調整が必要',
		shenheyuanyindesc:'この時間帯は占有されています。別の日付または時間帯を選択して再提出してください。',
		wancheng:'完了',
		chulizhong:'処理中',
		daichuli:'処理待ち',
		houtaishenhe:'管理者審査',
		chanshengmiyao:'キー生成',
		youjiankuaidi:'メール通知',
		kechakan:'閲覧可能',
		jinwanxinpinfuli:'今晩新商品ライブ',
		chehuishenqing:'申請を撤回',
		chongxinshenqing:'再申請',
		zhibojinyao:'配信キー',
		zhibojian:'配信ルーム',
		keyongshiduan:'利用可能時間',
		youxiao:'有効',
		tuiliudizhi:'プッシュURL',
		tuiliumamiyao:'ストリームキー',
		youjiantongzhidesc:'同じルームと時間帯ではキーは再生成されません。',
		yifasong:'送信済み',
		fuzhiquanbu:'すべてコピー',
		fuzhichenggong:'コピー成功',
		youjiantongzhi:'メール通知',
		zhiboshenhetongguo:'配信審査通過',
		shoujianren:'受信者',
		youjianneirongdesc:'配信ルーム、利用可能時間帯、プッシュ/プルURL、キー、配信前設定入口を含みます',
		youjianbianhao:'メールID',
		chongxinfasong:'再送信',
		yinyuedaren:'音楽',
		wudaodaren:'ダンス',
		yanzhi:'ビジュアル',
		jichushezhi:'基本設定',
		yishangchuan:'アップロード済み',
		zhiboshangpin:'配信商品',
		laiziyunimall:'UNImallストアから',
		jian:'件',
		zhiboliucheng:'配信フロー',
		liuchang:'滑らか',
		gaoqing:'HD',
		chaoqing:'超HD',
		languang:'ブルーレイ',
		tongguo:'通過',
		jinxingzhong:'進行中',
		daikaiqi:'待機中',
		qianzhizuoye:'事前準備',
		qingshangchuan:'アップロード',
		shangpinxuhao:'番号',
		shangpinshoutu:'商品画像',
		shangpinmingcheng:'商品名',
		shangchengkucun:'ストア在庫',
		zhibokucun:'配信在庫',
		shangchengjiage:'ストア価格',
		zhibojiage:'配信価格',
		caozuo:'操作',
		yichu:'削除',
		zhibojiansetting:'ルーム設定',
		kaiqishengyin:'音声オン',
		guanbishengyin:'音声オフ',
		kaiqidanmu:'弾幕オン',
		guanbidanmu:'弾幕オフ',
		kaiqimeiyan:'美顔オン',
		guanbimeiyan:'美顔オフ',
		kaiqimaikefeng:'マイクオン',
		guanbimaikefeng:'マイクオフ',
		kaiqimaike:'マイクオン',
		guanbimaike:'マイクオフ',
		gonggao:'お知らせ',
		fenxianglianjie:'リンク共有',
		xietongzhibo:'コラボ配信',
		yaoqingjinbo:'アシスタント招待',
		tongyikongzhi:'一括管理',
		tichuzhubozb:'選択を削除',
		zhuborenshushangxian:'アシスタント上限',
		ren:'人',
		tongzhibojinyao:'配信キーと同じ',
		zhuboquanxian:'アシスタント権限',
		yunxufayan:'発言を許可',
		yunxukamai:'マイクを許可',
		yunxukashipin:'ビデオを許可',
		yikaiqi:'有効',
		shengchengyaoqingjinyao:'招待キーを生成',
		xietongzhiborenshu:'コラボ配信人数',
		dangqianzhibo:'現在のアシスタント',
		kenenghaiyaoqing:'あと招待可能',
		weizhibo:'名',
		baocunshangxian:'上限を保存',
		fenxiangyaoqing:'招待を共有',
		yaoqinglianjie:'招待リンク',
		fenxiangfangshi:'共有方法',
		fuzhilianjie:'リンクをコピー',
		baocunerweima:'QRコードを保存',
		fuzhiyaoqinglianjie:'招待リンクをコピー',
		zhubo:'アシスタント',
		guanli:'管理',
		yijinru:'参加済み',
		maikefeng:'マイク',
		shexiangtou:'カメラ',
		sheweizhuyemian:'メイン画面に設定',
		quxiaozhuyemian:'メイン画面を解除',
		tichuzhibo:'配信ルームから削除',
		tichuhoubukejinru:'削除後は再入室できません',
		tongyikongmai:'一括マイク管理',
		quanjukongzhi:'全体管理',
		quantijingyin:'全員ミュート',
		yunxuzhubokaimai:'アシスタントのマイクを許可',
		yunxuzhubokaishipin:'アシスタントのビデオを許可',
		huifukaimai:'ミュート解除',
		guanbishipin:'ビデオ無効',
		kaiqishipin:'ビデオオン',
		yunxushipin:'ビデオ許可',
		yingyongshezhi:'設定を適用',
		shipin:'ビデオ',
	kaimai:'マイクオン',
	weikaiqi:'オフ',
	shipinkaiqi:'ビデオオン',
	shipinguanbi:'ビデオオフ',
	bimai:'ミュート',
	yunxufayan:'チャット許可',
	jinzhifayan:'チャット禁止',
	zhuboxiwei:'コホスト席',
		guankanzhibo:'視聴する',
		goumai:'購入',
		goumaishangpin:'商品購入',
		yishouqing:'売り切れ',
		dashang:'チップ',
		chakangg:'お知らせ確認',
		quxiao:'キャンセル',
		queren:'確認',
		wodequanbao:'マイウォレット',
		jiangjie:'解説',
		jiangjiezhong:'解説中',
		kucun:'在庫',
		qrcodenotexist:'QRコードが見つかりません',
		qrcodesaved:'QRコードを保存しました',
		wodeqianbao:'マイウォレット',
		lianshangbaobishibei:'オンチェーントークン',
		zonge:'合計',
		keyongshuliang:'利用可能',
		dongjieshuliang:'凍結',
		chakanliushui:'取引履歴',
		chongzhitip:'同チェーンのみ対応。ブロックチェーン確認後の送金は取消不可。',
		chongzhishuliang:'入金額',
		yujidaozhang:'到着予定',
		shijidaozhang:'実際到着',
		lijichongzhi:'今すぐ入金',
		chongzhierweima:'入金QRコード',
		chongbidizhi:'入金アドレス',
		fuzhidizhi:'アドレスをコピー',
		chongzhichenggong:'入金成功',
		chongbichenggong:'入金完了',
		bizhong:'トークン',
		shuliang:'数量',
		shijian:'時間',
		tibidizhi:'出金アドレス',
		tibishisuan:'出金試算',
		zuiditixianjin:'最低出金額',
		meiriyushutixian:'毎日残り出金額',
		keyongyu:'利用可能残高',
		tijiaotibi:'出金を提出',
		xuanzetibidizhi:'出金アドレスを選択',
		sousuodizhi:'アドレスを検索',
		xuanze:'選択',
		querentbi:'出金確認',
		xuanzedashangbizhong:'チップ通貨を選択',
		yue:'残高',
		dashangjine:'チップ金額',
		zhanshidashangxinxi:'チップ情報を表示',
		zidingyi:'カスタム',
		querendashang:'チップを確認',
		zaixianguanzhong:'視聴者',
		yizhibo:'配信中',
		jieshizhibo:'配信終了',
		zhibozhong:'配信中',
		zanwuzaixianguanzhong:'視聴者がいません',
		shangchuanshibai:'動画のアップロードに失敗しました。しばらくしてから再試行してください',
		qingshurucontent:'タイトルを入力して動画をアップロードしてください',
		fabuchenggong:'公開成功',
		fabushibai:'公開失敗',
		qingshurushuju:'データを入力してください',
		confirmDelete:'この動画を削除しますか？',
		shanchuchenggong:'削除成功',
		confirmWithdraw:'この動画を撤回しますか？',
		chehuichenggong:'撤回成功',
		yongjiujinyan:'永久BAN',
		jiaruzhibo:'ライブ参加',
		jiaruxietongzhibo:'コラボライブ参加',
		tuichuxietongzhibo:'コラボライブ退出',
		zhubojinyao:'コラボキー',
		qingshuruzhubojinyao:'コラボキーを入力してください',
		jiaru:'参加',
		shenqingchenggong:'申請成功',
		youxiaoqi:'有効期間',
		tichubenchang:'追放',
		zhanshidashangxiaoxi:'投げ銭メッセージを表示',
		zanwugonggao:'お知らせはありません',
		dashang:'投げ銭',
		songgei:'贈呈',
		ge:'個',
		bi:'コイン',
		zanweiyourenjiaruxietongzhibo:'まだ誰もコラボ配信に参加していません',
		zanweikaiqi:'コラボ配信はまだ有効になっていません'
	},
}



// WEBPACK FOOTER //
// ./src/i18n/langs/ja.js